import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconSparkle = deprecatedComponent({
    displayName: 'IconSparkle',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            xmlSpace: "preserve",
            style: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinecap: 'round',
                strokeLinejoin: 'round'
            },
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "m2.492 15.447.319.078a7.272 7.272 0 0 1 5.33 5.271l.106.416c.287 1.126 1.873 1.165 2.215.054l.252-.817a7.273 7.273 0 0 1 5.142-4.905l.391-.1c1.105-.284 1.168-1.829.091-2.203l-1.052-.365a7.272 7.272 0 0 1-4.511-4.555l-.322-.957c-.361-1.076-1.896-1.035-2.2.058l-.15.537a7.273 7.273 0 0 1-4.738 4.961l-.961.315c-1.1.361-1.038 1.939.088 2.212Z",
            style: {
                fill: 'none',
                fillRule: 'nonzero',
                stroke: '#000',
                strokeWidth: '1.5px'
            }
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M19.217 2.219c-.295-.878-1.549-.845-1.797.047l-.071.254a3.047 3.047 0 0 1-1.985 2.079l-.455.149c-.898.295-.847 1.583.071 1.806l.152.037a3.049 3.049 0 0 1 2.233 2.208l.05.197c.234.92 1.53.952 1.809.045l.119-.387a3.049 3.049 0 0 1 2.154-2.055l.186-.048c.901-.231.953-1.493.074-1.798l-.498-.173a3.045 3.045 0 0 1-1.89-1.908l-.152-.453Z",
            style: {
                fill: 'none',
                fillRule: 'nonzero',
                stroke: '#000',
                strokeWidth: '1.5px',
                strokeLinecap: 'square'
            }
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconSparkle };
